import { map } from 'rxjs/operators';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { locales } from './locales';

export class ChargeyeTranslateLoader extends TranslateHttpLoader {
    supportedLanguages = locales.map((l) => l.value);
    secondaryLanguage = null;

    constructor(http: HttpClient) {
        super(http, './assets/localizations/', '.json');
    }

    getTranslation(lang: string): Observable<any> {
        if (this.supportedLanguages.indexOf(lang) === -1) {
            lang = 'en';
        }

        const translations$ = super.getTranslation(lang).pipe(
            map((dict) => {
                return this.formatLocales(dict);
            })
        );

        return translations$;
    }

    /**
     * Formats locale files from `"key": {"text": "string", "comment": "string"}` format
     * to `key: "string"` format supported by angular-translate
     */
    private formatLocales(json) {
        return Object.keys(json).reduce((obj, key) => {
            if (typeof json[key].text === 'string' && typeof json[key].comment === 'string') {
                obj[key] = json[key].text;
            } else if (typeof json[key] === 'object') {
                obj[key] = this.formatLocales(json[key]);
            }
            return obj;
        }, {});
    }
}
